// Sensor temperature, humidity, and hysteresis conversions.
const cToF = c => (c * 9) / 5 + 32;
const fToC = f => ((f - 32) * 5) / 9;
const fToRaw = f => Math.round(((f + 49) / 315) * 65535);
export const cToRaw = c => fToRaw(cToF(c));
export const rawToF = raw => (raw / 65535) * 315 - 49;
export const rawToC = raw => fToC(rawToF(raw));

// Humidity helpers
const rawToRh = raw => (raw / 65535) * 125 - 6;
export const rhToRaw = rh => Math.round(((rh + 6) / 125) * 65535);
export const displayRh = raw => Math.round(rawToRh(raw));
export const inputToRawRh = value => rhToRaw(parseFloat(value));

// DELTA (hysteresis) conversions: do use -49 offset
const rawToDeltaF = raw => (raw / 65535) * 315;
const deltaFToRaw = f => Math.round((f / 315) * 65535);
const rawToDeltaC = raw => (rawToDeltaF(raw) * 5) / 9;
const deltaCToRaw = c => deltaFToRaw((c * 9) / 5);

// Display based on measurement system
export const displayTemp = (raw, measurementSystem) =>
  measurementSystem === 'imperial' ? Math.round(rawToF(raw)) : Math.round(rawToC(raw));
export const inputToRawTemp = (value, measurementSystem) =>
  measurementSystem === 'imperial' ? fToRaw(parseFloat(value)) : cToRaw(parseFloat(value));
export const displayDeltaTemp = (raw, measurementSystem) =>
  measurementSystem === 'imperial' ? Math.round(rawToDeltaF(raw)) : Math.round(rawToDeltaC(raw));
export const inputToRawDeltaTemp = (value, measurementSystem) =>
  measurementSystem === 'imperial' ? deltaFToRaw(parseFloat(value)) : deltaCToRaw(parseFloat(value));

/**
 * Resolve a REST display value or localize a raw socket reading.
 *
 * @param {object|null} reading sensor reading envelope ({value, raw, unit})
 * @param {'temperature'|'humidity'} readingType
 * @param {'imperial'|'metric'} measurementSystem
 * @returns {{value: number|null, unit: string}}
 */
export const resolveSensorReadingDisplay = (reading, readingType, measurementSystem) => {
  const fallbackUnit = readingType === 'temperature' ? (measurementSystem === 'imperial' ? '°F' : '°C') : '%';
  if (reading?.value != null) {
    return { value: reading.value, unit: reading.unit || fallbackUnit };
  }
  if (reading?.raw == null) {
    return { value: null, unit: fallbackUnit };
  }
  const value = readingType === 'temperature' ? displayTemp(reading.raw, measurementSystem) : displayRh(reading.raw);
  return { value, unit: fallbackUnit };
};
